import { makeStyles } from "@material-ui/core";
import { IImageApplogo } from "Components/Image/interfaces-image";

export const stylesImageAppLogo = makeStyles({
    avatar: (props: IImageApplogo) => ({
        width: props.width ? props.width : '80px',
        height: props.height ? props.height : '80px'
    })
})